/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WebApiEndpointsUsersRegisterRequest { 
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    password?: string | null;
    roleIds?: Array<string> | null;
    salesRepresentativeId?: string | null;
    employerId?: string | null;
}

